import {ImportConfig} from '../../../../../projects/mydocma/import-export/src/lib/import/configs/import.config';
import {SelectItem} from '../../../../../projects/mydocma/import-export/src/lib/import/models/select-item';

export const fieldsToImportConfig: ImportConfig = {
    fields: [
        {
            name: 'firstName',
            label: 'field-label-config.firstName',
            type: 'string',
            required: true
        },
        {
            name: 'lastName',
            label: 'field-label-config.lastName',
            type: 'string',
            required: true
        },
        {
            name: 'birth',
            label: 'field-label-config.birth',
            type: 'Date',
        },
        {
            name: 'age',
            label: 'field-label-config.age',
            type: 'number'
        },
        {
            name: 'userName',
            label: 'field-label-config.userName',
            type: 'string'
        },
        {
            name: 'nationality',
            label: 'field-label-config.nationality',
            type: 'string'
        },
        {
            name: 'postCode',
            label: 'field-label-config.postCode',
            type: 'number',
        },
        {
            name: 'city',
            label: 'field-label-config.city',
            source: [
                {id: 1, text: 'Munich'},
                {id: 2, text: 'Kyiv'},
                {id: 3, text: 'Tallinn'},
                {id: 4, text: 'Austria'},
            ],
            type: 'string',
            required: true
        },
        {
            name: 'country',
            label: 'field-label-config.country',
            getSource: (): Promise<SelectItem[]> => {
                return Promise.resolve([
                    {id: 1, text: 'South Korea'},
                    {id: 2, text: 'South Africa'},
                    {id: 3, text: 'Thailand'},
                    {id: 4, text: 'USA'}
                ]);
            },
            type: 'string',
            required: true
        }
    ]
};
